export const FO_Status = [
  {key: 'Ενεργό Film Office', value: true},
  {key: 'Ανενεργό Film Office', value: false}
];